<div class="document-repository-wrapper">
  <app-toolbar />

  <section class="feature-shell">
    <!-- Page header -->
    <div class="page-header">
      <p class="page-description">
        Easily preview, update documents, and monitor signature requests with notifications.
      </p>
      @if (canReplaceFile) {
        <app-az-button
          [label]="'Replace File'"
          [icon]="'upload'"
          [iconPosition]="'left'"
          (click)="openUploadModal()"
        />
      }
    </div>

    <!-- Loading state -->
    @if (loading()) {
      <div class="loading-state" aria-live="polite" aria-label="Loading documents">
        <span class="material-symbols-outlined spinning">progress_activity</span>
      </div>
    }

    <!-- Error state -->
    @if (loadError()) {
      <div class="error-state" role="alert">{{ loadError() }}</div>
    }

    <!-- Document table -->
    @if (!loading() && !loadError()) {
      <app-az-table
        data-testid="bcr-171-document-table"
        [data]="displayDocuments"
        [columns]="columns"
        [actions]="actions"
        [emptyMessage]="'No documents found'"
        [clickable]="userPermissionsService.hasPstMemberRole()"
        (rowClick)="onDocumentRowClick($event)"
      />
    }
  </section>

  <app-footer />

  <app-az-document-update-modal
    [isOpen]="showUploadModal()"
    [documentTypes]="documentTypes"
    [allowedFileTypes]="['pdf']"
    [showCommentBox]="false"
    [disableDocumentTypeSelector]="false"
    [showNotificationStep]="true"
    [contactsValidationWarning]="contactsValidationWarning()"
    [incompleteContacts]="incompleteContacts()"
    [isValidatingContacts]="isValidatingContacts()"
    (close)="closeUploadModal()"
    (stepOneConfirmed)="onStepOneConfirmed($event)"
    (recipientGroupChanged)="onRecipientGroupChanged($event)"
    (notifyConfirmed)="onNotifyConfirmed($event)"
  />

  <app-status-change-modal
    #uploadStatusModal
    [isOpen]="isStatusModalOpen()"
    [initialState]="'processing'"
    [title]="statusModalTitle()"
    [processingResultTitle]="statusModalProcessingTitle()"
    (close)="closeStatusModal()"
  />

  <app-status-change-modal
    [isOpen]="isPendingWarningOpen()"
    [initialState]="'custom-confirm'"
    [title]="'Replace File'"
    [customMessage]="'This document currently has a signing process in progress. Replacing it now will cancel the current process and reset all signing statuses. Do you want to continue?'"
    [customNoButtonLabel]="'No'"
    [customYesButtonLabel]="'Yes'"
    (close)="onPendingWarningNo()"
    (customNo)="onPendingWarningNo()"
    (customYes)="onPendingWarningYes()"
  />
</div>
